import UploadButton from "./UploadButton";

const UploadNewVersionButton = ({ onChange, disabled, accept }) => {
  return (
    <UploadButton
      onChange={onChange}
      disabled={disabled}
      label="Upload New Version"
      buttonProps={{
        variant: "contained",
        color: disabled ? "primary" : "success",
        sx: {
          pr: 1.5,
          pl: 1,
          py: 0,
          lineHeight: "35px",
          borderRadius: "20px",
          width: 210,
        },
        startIcon: (
          <img
            src={`assets/buttons/upload${disabled ? "-disabled" : ""}.svg`}
            alt="Upload New Version"
          />
        ),
      }}
      inputProps={{ accept: accept }}
    ></UploadButton>
  );
};

export default UploadNewVersionButton;
